"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.referenceContainer = exports.default = exports.PaymentContainer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _i18n = require("../../i18n");
var _commonUtils = require("../../utils/commonUtils");
var _Spinner = _interopRequireDefault(require("../spinner/Spinner"));
var _core = require("../../core/services/core");
var _PaymentContainerList = require("./PaymentContainerList");
var _actions = require("../../contexts/actions");
var _contexts = require("../../contexts");
var _PaymentAccordion = _interopRequireDefault(require("../paymentAccordion/PaymentAccordion"));
var _SubmitButtonWrapper = _interopRequireDefault(require("../submit/SubmitButtonWrapper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * It holds the reference of all components required for further operations.
 * We intentionally mutate this object when a write operation is required.
 **/
var referenceContainer = {
  paymentSubmitBtn: null,
  paymentContainer: null,
  emailInputField: null,
  phoneInputField: null,
  nameInputField: null,
  paymentComponent: null,
  billingInfoHeader: null
};
exports.referenceContainer = referenceContainer;
var PaymentContainer = function PaymentContainer(props) {
  var customSpinner = props.customSpinner,
    inputCustomData = props.inputCustomData,
    components = props.components,
    customFunctions = props.customFunctions,
    customInitiateConfigCallback = props.customInitiateConfigCallback,
    customAuthCallBack = props.customAuthCallBack;
  inputCustomData.cart.languageCode = (0, _commonUtils.convertToAcceptedLocale)(inputCustomData.cart.languageCode);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoader = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    processing = _useState4[0],
    setProcessing = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    paymentMethodsList = _useState6[0],
    setPaymentMethodsList = _useState6[1];
  var _useContext = (0, _react.useContext)(_contexts.PaymentContext),
    paymentDispatch = _useContext.dispatch,
    activePaymentMethods = _useContext.state.activePaymentMethods;
  var _useContext2 = (0, _react.useContext)(_contexts.AdyenContext),
    adyenDispatch = _useContext2.dispatch;
  var _useContext3 = (0, _react.useContext)(_contexts.PaypalContext),
    paypalDispatch = _useContext3.dispatch;
  var _useContext4 = (0, _react.useContext)(_contexts.NativeContext),
    nativeDispatch = _useContext4.dispatch;
  var _useContext5 = (0, _react.useContext)(_contexts.ZippayContext),
    zippayDispatch = _useContext5.dispatch;
  var _useContext6 = (0, _react.useContext)(_contexts.GooglePayContext),
    googlePayDispatch = _useContext6.dispatch;
  var _useContext7 = (0, _react.useContext)(_contexts.ApplePayContext),
    applePayDispatch = _useContext7.dispatch;
  var commonProps = {
    components: components,
    loading: loading,
    setLoader: setLoader,
    processing: processing,
    setProcessing: setProcessing,
    inputCustomData: inputCustomData,
    customAuthCallBack: customAuthCallBack,
    paymentDispatch: paymentDispatch,
    customFunctions: customFunctions
  };
  // Get the list of supported payment methods and filter by active payment methods
  var supportedPaymentMethods = (0, _PaymentContainerList.paymentContainerList)({
    commonProps: commonProps
  });
  (0, _react.useEffect)(function () {
    paymentDispatch((0, _actions.updateCartAmount)(inputCustomData.cart.cartAmount));
  }, [inputCustomData.cart.cartAmount]);
  (0, _react.useEffect)(function () {
    var paymentMethodsList_ = activePaymentMethods ? activePaymentMethods.reduce(function (activeList, e) {
      if (supportedPaymentMethods[e]) {
        return activeList = [].concat(_toConsumableArray(activeList), [supportedPaymentMethods[e]]);
      }
      return activeList;
    }, []) : [];
    setPaymentMethodsList(paymentMethodsList_);
  }, [activePaymentMethods]);
  (0, _react.useEffect)(function () {
    setLoader(true);
    var dispatches = {
      paymentDispatch: paymentDispatch,
      adyenDispatch: adyenDispatch,
      paypalDispatch: paypalDispatch,
      nativeDispatch: nativeDispatch,
      zippayDispatch: zippayDispatch,
      googlePayDispatch: googlePayDispatch,
      applePayDispatch: applePayDispatch
    };
    paymentDispatch((0, _actions.updateCartAmount)(inputCustomData.cart.cartAmount));
    (0, _core.configureCustomData)(inputCustomData, dispatches);
    var payload = {
      checkoutId: inputCustomData.checkoutId,
      countryCode: inputCustomData.cart.countryCode,
      locale: inputCustomData.cart.languageCode,
      cartAmount: inputCustomData.cart.cartAmount,
      currencyCode: inputCustomData.cart.currencyCode
    };
    (0, _core.getPaymentMethods)(_objectSpread({}, payload), function (data) {
      setLoader(false);
      customInitiateConfigCallback(data);
    }, dispatches);
  }, [inputCustomData.cart.checkoutId]);
  return /*#__PURE__*/_react.default.createElement(_i18n.I18nProvider, {
    locale: inputCustomData.cart.languageCode
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-container"
  }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    spinner: customSpinner,
    loading: loading,
    processing: processing
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: 'payment-widget__payment-methods ' + (loading ? 'hidden' : '')
  }, activePaymentMethods ? /*#__PURE__*/_react.default.createElement(_PaymentAccordion.default, {
    paymentMethods: paymentMethodsList,
    customFunctions: customFunctions
  }) : null), /*#__PURE__*/_react.default.createElement(_SubmitButtonWrapper.default, {
    components: components,
    referenceContainer: referenceContainer,
    customFunctions: customFunctions
  })));
};
exports.PaymentContainer = PaymentContainer;
PaymentContainer.propTypes = {
  customSpinner: _propTypes.default.node.isRequired,
  inputCustomData: _propTypes.default.object.isRequired,
  components: _propTypes.default.array,
  customFunctions: _propTypes.default.object.isRequired,
  customInitiateConfigCallback: _propTypes.default.func.isRequired,
  customAuthCallBack: _propTypes.default.func.isRequired
};
var _default = PaymentContainer;
exports.default = _default;